module.exports = "/_next/static/images/nowNodes-tweet-logo-6c3b4084c65c3793b3142d90fb76adec.png";